import { render } from "./ReportsDashboard.vue?vue&type=template&id=226ff126&scoped=true"
import script from "./ReportsDashboard.vue?vue&type=script&lang=js"
export * from "./ReportsDashboard.vue?vue&type=script&lang=js"

import "./ReportsDashboard.vue?vue&type=style&index=0&id=226ff126&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226ff126"]])

export default __exports__